import React from 'react';
import Icon from '@mdi/react';
import { mdiCamera } from '@mdi/js';

import { FormProps } from './types';

function YesNo({
  question, value, name, onChange,
}: FormProps, ref) {
  if (question.type !== 'yes-no') return null;

  return (
    <div className="flex w-100 flex-align-items-center flex-justify-content-space-between">
      <div className="dynamic-form-label inline">{question.label}</div>
      <div className="flex dynamic-form-input-group">
        <div className="dynamic-form-input width-none">
          <select value={value} name={name} onChange={onChange} className="width-auto" ref={ref}>
            <option value="" disabled>---</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>
        {
          question.photo && (
            <div>
              <button type="button" aria-label="Photo" className="dynamic-form-input icon">
                <Icon path={mdiCamera} size={1} />
              </button>
            </div>
          )
        }
      </div>
    </div>
  );
}

export default React.forwardRef(YesNo);
